module.exports = class Level {
    constructor() {
        this.id     = 0;
        this.name   = '';
        this.value  = '';
    }
};
